module.exports = __webpack_public_path__ + "img/A3M7_new.2fc1f19a.jpg";